var map = {
	"./ai.png": "8053",
	"./avi.png": "75c2",
	"./cdr.png": "53c2",
	"./default.png": "1c71",
	"./dwg.png": "b3f8",
	"./excel.png": "fac8",
	"./htm.png": "8cf0",
	"./jpg.png": "a264",
	"./mov.png": "c4fd",
	"./mp3.png": "bebf",
	"./mp4.png": "e57b",
	"./pdf.png": "7501",
	"./ppt.png": "2efa",
	"./procreate.png": "7471",
	"./psd.png": "9636",
	"./rps.png": "6e6a",
	"./txt.png": "a69d",
	"./wav.png": "b5f6",
	"./word.png": "3983",
	"./zip.png": "9444",
	"./zprj.png": "4553"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34fd";